<template>
	<div
		v-if="shouldDisplay"
		:class="`relative ${blok.height} ${blok.visibility ? blok.visibility.join(' ') : ''}`"
	>
		<StoryblokComponent v-if="blok?.promo?.[0]" :blok="blok.promo[0]" />
		<!-- Background Image -->
		<NuxtImg
			:src="imageObject?.image?.filename"
			alt=""
			class="w-full h-full object-cover absolute inset-0"
			provider="storyblok"
			v-bind="imagePriority"
			format="webp"
			quality="80"
			sizes="sm:100vw md:100vw lg:100vw xl:1600px"
			:width="storyblokImgDimensions.width"
			:height="storyblokImgDimensions.height"
		/>

		<!-- Content Over Image -->
		<NuxtLink
			v-if="
				blok?.call_to_action?.length === 0 &&
				imageObject?.image_link?.cached_url
			"
			:to="localePath(imageObject?.image_link?.cached_url)"
		>
			<span v-if="!(blok.heading && blok.sub_heading)" class="sr-only">
				{{ imageObject?.image?.alt || "hero" }}
			</span>
			<HeroContent
				:blok="blok"
				:is-swiper="isSwiper"
				:is-category="isCategory"
				:styles-type="stylesType"
			/>
		</NuxtLink>
		<HeroContent
			v-else
			:blok="blok"
			:is-swiper="isSwiper"
			:is-category="isCategory"
			:styles-type="stylesType"
		/>
	</div>
</template>

<script setup lang="ts">
import type { BlokHero } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokHero;
	isSwiper?: boolean;
	isCategory?: boolean;
}
const { blok, isSwiper } = defineProps<Props>();
const imagePriority = useBlokImagePriority();

const localePath = useLocalePath();
const { shouldDisplay } = useDisplayBlock(blok.start_date, blok.end_date);

const storyblokImgDimensions = useStoryblokAssetDimensions(
	() => blok?.image?.[0]?.image?.filename
);

const stylesType = computed(() =>
	blok?.height?.includes("pb-") || !blok?.height ? "proportional" : "default"
);
const imageObject = computed(() => blok?.image?.[0] || null);
</script>
